// store/index.js
import { createStore } from 'vuex';

export default createStore({
  state: {
    fileUploadResult: null,
    selectedFile: null, // Сохранение выбранного файла
    folderTreeData: null,
    folderHash: '', // Сохранение введенного хэша
    tokens: [],
  },
  mutations: {
    setTokens(state, tokens) {
        state.tokens = tokens;
    },
    setAuthenticated(state, status) {
        state.isAuthenticated = status;
    },
    setAdminHash(state, hash) {
        state.adminHash = hash;
    },
    setError(state, error) {
        state.error = error;
    },
    setFileUploadResult(state, result) {
      state.fileUploadResult = result;
    },
    setSelectedFile(state, file) {
      state.selectedFile = file;
    },
    setFolderTreeData(state, data) {
      state.folderTreeData = data;
    },
    setFolderHash(state, hash) {
      state.folderHash = hash;
    },
  },
  actions: {
    saveAuthenticatedStatus({ commit }, status) {
        commit('setAuthenticated', status);
    },
    saveFileUploadResult({ commit }, result) {
      commit('setFileUploadResult', result);
    },
    saveAdminHash({ commit }, hash) {
        commit('setAdminHash', hash);
    },
    saveError({ commit }, error) {
        commit('setError', error);
    },
    saveSelectedFile({ commit }, file) {
      commit('setSelectedFile', file);
    },
    saveFolderTreeData({ commit }, data) {
      commit('setFolderTreeData', data);
    },
    saveFolderHash({ commit }, hash) {
      commit('setFolderHash', hash);
    },
    saveTokens({ commit }, tokens) {
      commit('setTokens', tokens);
    }
  },
  getters: {
    getFileUploadResult: (state) => state.fileUploadResult,
    getAuthenticatedStatus: (state) => state.isAuthenticated,
    getError: (state) => state.error,
    getAdminHash: (state) => state.adminHash,
    getSelectedFile: (state) => state.selectedFile,
    getFolderTreeData: (state) => state.folderTreeData,
    getFolderHash: (state) => state.folderHash,
    getTokens: (state) => state.tokens,
  }
});
